import { render } from "./FloatingActionButton.vue?vue&type=template&id=62ba269a&scoped=true"
import script from "./FloatingActionButton.vue?vue&type=script&lang=js"
export * from "./FloatingActionButton.vue?vue&type=script&lang=js"

import "./FloatingActionButton.vue?vue&type=style&index=0&id=62ba269a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ba269a"]])

export default __exports__